import { ViewEncapsulation, Component, OnInit, Output, EventEmitter, Renderer2, Inject } from '@angular/core';
import { GlobalService } from 'src/app/shared/global.service';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/platform-browser';
import { WindowRef } from 'src/app/services/windowService/WindowRef';

declare var $: any;

@Component({
    selector: 'app-agenda-virtual',
    templateUrl: './agenda-virtual.template.html',
    styleUrls: ['./agenda-virtual.component.scss'],
    encapsulation: ViewEncapsulation.None
})

/**
 * @author jnmartinez
 */
export class AgendaVirtualComponent implements OnInit {

    public opened = true;
    public menu: any;
    public accesibilidad = false;
    public checked = false;
    public checkedgif = true;
    public gif;
    public tamanoletra = 100;
    public style;
    public modificacionmenu;
    public modificacioncontenido;
    public aumentomenu = 18;
    public aumentocontenido = 18;
    public aumentoright = 0;
    public tamanioLetraApp = 100;
    public checkBlack: boolean;
    public checkPink: boolean;
    public checkGray: boolean;
    public checkTeclado: boolean;

    @Output() public fontValue = new EventEmitter();

    constructor(
        private global: GlobalService,
        private translate: TranslateService,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document,
        private windowService: WindowRef
    ) { }

    ngOnInit() {
        $('#spinnerClock').css('display', 'none');
        this.global.setThemeInit();
        this.menu = [];
        const theme = sessionStorage.getItem('theme');
        const lang = sessionStorage.getItem('idioma');
        this.translate.setDefaultLang(lang);
        this.checkTeclado = false;
        if (theme === 'yeti') {
            this.checked = false;
            this.checkBlack = false;
            this.checkGray = false;
            this.checkPink = false;
        } else {
            this.validarTema(theme);
        }
        this.opened = true;
    }

    habilitarModo() {
        if (this.checkTeclado) {
            $('.modo-teclado-inactivo').addClass('modo-teclado');
        } else {
            $('.modo-teclado-inactivo').removeClass('modo-teclado');
        }
    }

    // fromero
    // 02/07/2019
    // Valida el tema y activa o inactiva los checks
    validarTema(theme) {
        switch (theme) {
            case 'dark-white':
                this.checkBlack = true;
                this.checkGray = false;
                this.checkPink = false;
                break;
            case 'rosa-fucsia':
                this.checkPink = true;
                this.checkGray = false;
                this.checkBlack = false;
                break;
            case 'gris-blanco':
                this.checkGray = true;
                this.checkBlack = false;
                this.checkPink = false;
                break;
        }

        return theme;
    }

    public setAccesibilidad(accion: any) {

        if (accion) {
            this.accesibilidad = true;
        } else {
            this.accesibilidad = false;
        }
    }

    // fromero
    // 02/07/2019
    // Método para setear el tema de la aplicación

    public setTheme(temaSeleccionado?: any, event?) {
        let tema;
        if (event && event.target.checked) {
            tema = this.validarTema(temaSeleccionado);
        } else {
            tema = 'yeti';
        }
        this.global.theme(tema);
    }


    // fromero
    // 02/07/2019
    // método para restablecer ajustes predeterminados

    public restablecerAjustes(theme?: any) {
        this.setTheme(theme);
        this.checked = false;
        this.checkBlack = false;
        this.checkGray = false;
        this.checkPink = false;
        this.tamanioLetraApp = 100;
        this.setTamanoLetra('restablecer');
    }

    // fromero
    // 04/07/2019
    // metodo que altera la pripiedad font size del DOM para umentar el tamaño de letra
    setTamanoLetra(origen?: any) {
        $('body').css('font-size', (this.tamanioLetraApp).toString() + '%');
    }
}
